import { BookingEngine, Rates, roomData } from "../../index";
import Selectors from "./Selectors";
import waitForSelectors from "../../utilities/waitForSelectors";
import spaUrlChanged from "../../utilities/spaUrlChanged";
import { handleIntegrationInjector } from "../../hotelIntegrationHandlers";
import axios from "axios";
import {
  guestbookSites,
  environment,
} from "../../../settings/IntegrationConstants";
import moment from "moment";
import {
  setNativeValue,
  parsePrice,
  getBrowserInfo,
  getDeviceInfo,
  isNotEligibleForRewards
} from "../../utilities/utils";

declare global {
  interface Window {
    gb_data: any;
    _globalTracking: any;
    angular: any;
    jQuery: any;
  }
}

const gbData = window.gb_data;

const print = (s) => {
  const debug = process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'staging';
  if (debug) console.log('%c' + s, 'background: #fffcf2; color: #350091');
}

const Selfbook: BookingEngine = {
  name: gbData.bookingEngine,
  hotel: {
    name: gbData.hotel.name,
    isAutomated: gbData.hotel.isAutomated,
    rateCodeExclusions: gbData.hotel.rateCodeExclusions,
    rateCodeInclusions: gbData.hotel.rateCodeInclusions,
    packageRateExlusions: gbData.hotel.packageRateExlusions,
    exludeAllGroupCodes: gbData.hotel.exludeAllGroupCodes,
    exludeAllCorpCodes: gbData.hotel.exludeAllCorpCodes,
    whiteLabel: gbData.hotel.whiteLabel,
    dontAbTrack: true,
    memberCode: gbData.hotel.memberCode,
    memberCodeType: gbData.hotel.memberCodeType,
    showEnrollment: JSON.parse(
      sessionStorage.getItem("gbShowEnrollment") || "true"
    ),
    widgetIdentifier: gbData.widget.identifier,
    primaryColor: gbData.widget.primaryColor,
    secondaryColor: gbData.widget.secondaryColor,
    widgetAnchored: true, // gbData.widget.widgetAnchored,
    widgetWidth: gbData.widget.widgetWidth,
    widgetPositionTop: gbData.widget.widgetPositionTop,
    widgetPositionRight: gbData.widget.widgetPositionRight,
    widgetPositionBottom: gbData.widget.widgetPositionBottom,
    widgetPositionLeft: gbData.widget.widgetPositionLeft,
    inheritBeFont: gbData.widget.inheritBeFont,
    desktopEnrollmentPrimaryColor: gbData.widget.desktopEnrollmentPrimaryColor,
    benefits: gbData.widget.benefits,
  },
  selectors: Selectors,
  singlePageApp: true,
  requireResizeListener: true,
  widgetFixedPosition: false,//!gbData.widget.widgetAnchored,
  largeEnrollmentMessage: false,
  activeIntervals: [],
  promoCodes: [],
  widgetMobileAtWidth: 0,
  saveInfoAtConfirmation: true,

  /* ADDITIONAL NOTES */
  // can use comment // @ts-ignore to ignore out ts errors

  /**
   * Grab widget target
   * (not usually modified)
   */
  getWidgetTarget: () =>
    document.querySelector(Selfbook.selectors.widget.target),
  /**
   * Applies member code to room search at user login
   * Only applicable if we have an existing member code (Selfbook.hotel.memberCode)
   * Reference Travelclick.ts or SynxisGTM.ts for fleshed out example
   */
  getMemberCode: () => {
    const params = new URL(window.location.href).searchParams;
    const hotelID = window.gb_hotel_pid;

    // grab existing code if exists
    const groupPromoCode = params.get("promo")
      ? params.get("promo")
      : params.get("group");
    if (
      Selfbook.hotel.memberCode &&
      Selfbook.hotel.memberCode !== groupPromoCode
    ) {
      let beBaseUrl = "";
      let beParams = "";
      if (window.location.href.split("?").length === 1) {
        beBaseUrl = window.location.href.split("?")[0];
      } else {
        beBaseUrl = window.location.href.split("?")[0];
        beParams = window.location.href.split("?")[1];
      }

      let urlParams = new URLSearchParams(beParams);

      urlParams.delete("selfbook");
      urlParams.delete("hotel");
      urlParams.delete("group");
      urlParams.delete("promo");

      let paramsString = urlParams.toString();
      if (paramsString !== "") {
        paramsString += "&";
      }

      const memberRatesLink = `${beBaseUrl}?selfbook=true&hotel=${hotelID}&${paramsString}${Selfbook.hotel.memberCodeType}=${Selfbook.hotel.memberCode}`;
      window.location.href = memberRatesLink;
    }
  },
  /**
   * Clears out member code at user logout
   */
  clearMemberCode: () => {
    const hotelID = window.gb_hotel_pid;
    if (Selfbook.hotel.memberCode) {
      let beBaseUrl = "";
      let beParams = "";
      if (window.location.href.split("?").length === 1) {
        beBaseUrl = window.location.href.split("?")[0];
      } else {
        beBaseUrl = window.location.href.split("?")[0];
        beParams = window.location.href.split("?")[1];
      }

      let urlParams = new URLSearchParams(beParams);

      urlParams.delete("selfbook");
      urlParams.delete("hotel");
      urlParams.delete("group");
      urlParams.delete("promo");

      let paramsString = urlParams.toString();

      const memberRatesLink = `${beBaseUrl}?selfbook=true&hotel=${hotelID}&${paramsString}`;
      window.location.href = memberRatesLink;
    }
  },
  /**
   * Grab rates info and target to inject, Also applies rate exclusions if any exist
   * @returns ratesInfo[{rewardsAmount, shouldDisplay, targetElement},{},...] 
   */
  getRates: () => {
    // save rate code and rewards amount of currently selected rate
    function getSelectedRate() {
      setTimeout(function () {
        let selected = window.jQuery('input[aria-checked="true"]').first();
        let rate = selected.attr("value");
        sessionStorage.setItem("rateCode", rate);
      }, 250);
    }

    const ratesInfo: Rates[] = [];
    const rates = document.querySelectorAll(
      Selfbook.selectors.ratesPage.rates
    );

    if (rates.length > 0) {
      window.jQuery('input[data-testid="radio-card"]').on("click", function () {
        getSelectedRate();
        // saveRewardAmount();
      });
      getSelectedRate();
      // saveRewardAmount();
    }

    rates.forEach((rate: any, index: number) => {
      // This is where we'd like our "Earn $" banner message to injected
      const messageTarget = (rate as HTMLElement).firstElementChild;
      if (messageTarget) {
        const injectedElement = !!messageTarget.querySelector(
          Selfbook.selectors.ratesPage.ratesMessage
        )
          ? messageTarget.querySelector(
            Selfbook.selectors.ratesPage.ratesMessage
          )
          : document.createElement("div");
        if (
          !messageTarget.querySelector(
            Selfbook.selectors.ratesPage.ratesMessage
          ) &&
          injectedElement
        ) {
          injectedElement.setAttribute(
            "class",
            Selfbook.selectors.ratesPage.ratesMessage.substr(1)
          );
          messageTarget.appendChild(injectedElement);
        }

        const rateName = rate.getAttribute("data-rate-code");
        const rateDetails = JSON.parse(document.querySelector(`[id^="#sb-room-pricing"][id$="${rateName}"]`).textContent)
        const ratePrice = rateDetails.nightlyRates[0].amount_before_tax;
        const calculatedRewards = ratePrice * 0.15;
        let shouldDisplay = true;

        // simple rate code exclusions
        // const rateCodeExclusions = Selfbook.hotel.rateCodeExclusions;
        // for (const rateCodeExclusion of rateCodeExclusions as any) {
        //   if (rateCodeExclusion.rate_plan_code.toLowerCase() == rateName) {
        //     shouldDisplay = false;
        //   }
        // }

        shouldDisplay = ![rateName.toLowerCase()].some(isNotEligibleForRewards);
        // rateex end


        ratesInfo.push({
          rewardsAmount: (calculatedRewards as any).toFixed(0),
          shouldDisplay: shouldDisplay,
          target: injectedElement,
        });
      }
    });
    sessionStorage.setItem("rates", JSON.stringify(ratesInfo));

    // hide dynamic banners when settings or price breakdown popup is active
    setInterval(() => {
      if (document.querySelectorAll("div[aria-label='Basic Settings']").length > 0 ||
        document.querySelectorAll("div[aria-label='Global Settings']").length > 0 ||
        document.querySelectorAll("div[aria-label='Price Breakdown']").length > 0) {
        window.jQuery(".gb-rates-message").hide();
      } else {
        window.jQuery(".gb-rates-message").show();
      }
    }, 200);

    return ratesInfo;
  },
  /**
   * Grab the confirmation numbers on the final booking page
   * @returns confimationNumbers[], array used to account for multiple room bookings
   */
  getConfirmationNumber: () => {
    let confimationNumbers = [] as string[];
    document
      .querySelectorAll(
        Selfbook.selectors.confirmationPage.confirmationNumbers
      )
      .forEach((element) => {
        confimationNumbers.push(element.textContent);
      });
    return confimationNumbers;
  },
  /**
   * Grab the confirmation message target
   * (where to insert our confirmation message)
   */
  getConfirmationTarget: () =>
    document.querySelector(
      Selfbook.selectors.confirmationPage
        .confirmationMessageContainer
    ),
  /**
   * Grab displayed rates page currency symbol
   * Try to use window variables, url params, or scrape
   * can use:
   *    .textContent.trim().replace(/[\d\., ]/g, '');
   *    if we need to parse out price
   */
  getRatesCurrency: () => {
    let symbol = '$'
    let currentPage = document.querySelector(Selfbook.selectors.ratesPage.title).textContent.toLowerCase();

    // === ROOM DETAILS + ADTL RATES ===
    if (currentPage == "room details" || currentPage == "additional rates and packages") {
      let roomDetailsRateTarget = document.querySelector(Selfbook.selectors.ratesPage.rates);
      if (roomDetailsRateTarget)
        symbol = roomDetailsRateTarget.previousSibling.previousSibling.firstChild.textContent.trim().replace(/[\d\., ]/g, '');
      // === SUMMARY ===
    } else if (currentPage == "summary") {
      let summaryRateTarget = document.querySelector('dd');
      if (summaryRateTarget) {
        //cut out price part of string to get currency symbol
        symbol = summaryRateTarget.textContent.replace(/\d{1,3}(,\d{3})*(\.\d+)?$/, '');
      }
    }

    if (symbol && symbol.length <= 5) {
      sessionStorage.setItem('currencySymbol', symbol);
      return symbol;
    } else {
      sessionStorage.setItem('currencySymbol', '$');
      return '$';
    }
  },
  /**
   * Grab displayed checkout page currency symbol
   * Try to use window variables, url params, or scrape
   * can use:
   *  .textContent.trim().replace(/[\d\., ]/g, '');
   * if we need to parse out price
   */
  getCheckoutCurrency: () => {
    let symbol = '$'
    let currentPage = document.querySelector(Selfbook.selectors.ratesPage.title).textContent.toLowerCase();

    // === ROOM DETAILS + ADTL RATES ===
    if (currentPage == "room details" || currentPage == "additional rates and packages") {
      var roomDetailsRateTarget = document.querySelector(Selfbook.selectors.ratesPage.rates);
      if (roomDetailsRateTarget)
        symbol = roomDetailsRateTarget.previousSibling.firstChild.textContent.trim().replace(/[\d\., ]/g, '');
      // === SUMMARY ===
    } else if (currentPage == "summary") {
      var summaryRateTarget = document.querySelector('#sb-summary-taxes-fees dd');
      if (summaryRateTarget) {
        //cut out price part of string to get currency symbol
        symbol = summaryRateTarget.textContent.replace(/\d{1,3}(,\d{3})*(\.\d+)?$/, '');
      }
    }

    if (symbol && symbol.length <= 5) {
      sessionStorage.setItem('currencySymbol', symbol);
      return symbol;
    } else {
      sessionStorage.setItem('currencySymbol', '$');
      return '$';
    }
  },
  /**
   * Grab currency CODE to save in reservation payload
   * Try to use window variables, url params, or scrape
   */
  getCurrencyToSave: () => {
    return document.querySelector(
      Selfbook.selectors.paymentPage.currency
    );
  },
  /**
   * Grab language code
   */
  getLanguage: () => {
    const targetElement = document.querySelector("html") as HTMLElement;
    const lang = targetElement.getAttribute("lang")?.split("-")[0];
    if (typeof lang === "string") {
      return lang;
    } else {
      if (document.documentElement.lang) {
        return document.documentElement.lang;
      }
      return "en";
    }
  },
  /**
   * Grab our enrollment message container
   * (not usually modified)
   */
  getEnrollmentTarget: () =>
    document.querySelector(
      Selfbook.selectors.paymentPage.enrollmentMessageContainer
    ),
  /**
   * Grab reservation check in for reservation payload
   */
  getPaymentPageCheckinDate: () => {
    let checkInText = document
      .querySelector(Selfbook.selectors.paymentPage.checkin)
      .textContent.trim();
    let checkIn = moment(checkInText).format("YYYY-MM-DD");
    return checkIn;
  },
  /**
   * Grab reservation check in for reservation payload
   */
  getPaymentPageCheckoutDate: () => {
    let checkOutText = document
      .querySelector(Selfbook.selectors.paymentPage.checkout)
      .textContent.trim();
    let checkIn = moment(checkOutText).format("YYYY-MM-DD");
    return checkIn;
  },
  /**
   * Prefill user info on payment page if user logged in
   * (not usually modified)
   */
  prefillUserInfo: (firstName = "", lastName = "", email = "") => {
    waitForSelectors(Selfbook.selectors.paymentPage.firstname, () => {
      const emailInput = document.querySelector(
        Selfbook.selectors.paymentPage.email
      );
      const firstNameInput = document.querySelector(
        Selfbook.selectors.paymentPage.firstname
      );
      const lastNameInput = document.querySelector(
        Selfbook.selectors.paymentPage.lastname
      );
      const event = new Event("input", { bubbles: true });

      setNativeValue(firstNameInput, firstName);
      firstNameInput.focus();
      firstNameInput.dispatchEvent(event);
      firstNameInput.blur();

      setNativeValue(lastNameInput, lastName);
      lastNameInput.focus();
      lastNameInput.dispatchEvent(event);
      lastNameInput.blur();

      setNativeValue(emailInput, email);
      emailInput.focus();
      emailInput.dispatchEvent(event);
      emailInput.blur();

      spaUrlChanged(() => {
        Selfbook.prefillUserInfo(firstName, lastName, email);
      });
    });
  },
  /**
   * Grab email from payment page input
   * (not usually modified)
   */
  getGuestEmail: () =>
    document
      .querySelector(Selfbook.selectors.paymentPage.email)
      .value.trim(),
  /**
   * Grab first name from payment page input
   * (not usually modified)
   */
  getGuestFirstName: () =>
    document
      .querySelector(Selfbook.selectors.paymentPage.firstname)
      .value.trim(),
  /**
   * Grab last name from payment page input
   * (not usually modified)
   */
  getGuestLastName: () =>
    document
      .querySelector(Selfbook.selectors.paymentPage.lastname)
      .value.trim(),
  /**
   * Grab rate TYPE from payment page cart
   * Should be a name like "Best Available" if possible and not just "BAR"
   */
  getRateType: () => {
    let rateNames: string[] = [];
    let rates = document.querySelectorAll(
      Selfbook.selectors.paymentPage.rateNames
    );
    rates.forEach((item: any) => {
      rateNames.push(item.textContent);
    });

    return rateNames;
  },
  /**
   * Grab room name for reservation payload
   */
  getRoomName: () => {
    let roomNames: string[] = [];
    let rooms = document.querySelectorAll(
      Selfbook.selectors.paymentPage.roomNames
    );
    rooms.forEach((item: any) => {
      roomNames.push(item.textContent);
    });

    return roomNames;
  },
  /**
   * Grab number of adults, used in package rate exclusion calculations
   */
  getNumberOfAdults: () => {
    let adults = document.querySelector(
      Selfbook.selectors.paymentPage.adults
    );
    return adults;
  },
  /**
   * Grab number of days, used in package rate exclusion calculations
   */
  getNumberOfDays: () => {
    let days = document.querySelector(
      Selfbook.selectors.paymentPage.adults
    );
    return days;
  },
  /**
   * Grab list of rate codes, used in package rate exclusion calculations
   */
  getRateTypes: () => {
    let rateNames: string[] = [];
    let rates = document.querySelectorAll(
      Selfbook.selectors.ratesPage.ratesCodes
    );
    rates.forEach((item: any) => {
      rateNames.push(item.getAttribute("data-rate-code").trim());
    });
    return rateNames;
  },
  /**
   * Multiple use cases
   * 1) Grab all promo/group codes applied
   * If multiple can be applied at once, store them all to Selfbook.promoCodes
   * then retrieve them in getAllPromoCodes
   *
   * 2) just return the one code if distincy
   */
  getPromoCode: () => {
    let promoCode = "";
    // return document.querySelector(Selfbook.selectors.paymentPage.promoCode).innerText;
    return promoCode;
  },
  getGroupCode: () => {
    let groupCode = "";
    // return document.querySelector(Selfbook.selectors.paymentPage.groupCode).innerText;
    return groupCode;
  },
  getAllPromoCodes: () => {
    return Selfbook.promoCodes
      ? Selfbook.promoCodes.join(", ")
      : "";
  },
  /**
   * Grab subtotal at checkout to save
   */
  getSubtotal: () => {
    let subtotals: number[] = [];
    return subtotals;
  },
  /**
   * Grab grand total with taxes and fees at checkout to save
   */
  getTotalWithTaxes: () => {
    // Example multiroom
    let grandTotals: number[] = [];

    // also check for datalayer or window var
    const cart = document.querySelector(
      Selfbook.selectors.paymentPage.cartTarget
    );

    cart.forEach((item: any) => {
      const total = parsePrice(
        document.querySelector(
          Selfbook.selectors.paymentPage.total
        ).textContent
      );
      grandTotals.push(total);
    });

    return grandTotals;
  },
  /**
   * Save reservation data 
   */
  getReservationData: () => {
    const taxedRate = window.gb_data.hotel.taxedRate;
    let resData: roomData[] = [];
    let selfbookData = (window as any).rewardProgramData;

    resData.push({
      email: selfbookData.email,
      first_name: selfbookData.firstName,
      last_name: selfbookData.lastName,
      confirmation_number: selfbookData.confirmationNumber,
      checkin_date: selfbookData.checkIn,
      checkout_date: selfbookData.checkOut,
      rate_type: selfbookData.rate_code,
      room_name: selfbookData.roomType,
      currency_code: selfbookData.currency,
      lang_code: Selfbook.getLanguage(),
      total: (Number(selfbookData.totalPriceLessTaxes) / taxedRate).toString(),
      total_with_taxes: selfbookData.totalPrice,
      hotel_identifier: window.gb_data.widget.identifier,
      agreed_enrollment_checked: sessionStorage.getItem(
        "gbEnrolledChecked"
      ) as string,
      ab_version_viewed: sessionStorage.getItem(
        "gbShowEnrollment"
      ) as string,
      browser_info: getBrowserInfo(),
      is_mobile: getDeviceInfo(),
      promo_code: selfbookData.promo_code,
      group_code: selfbookData.group_code,
      rate_code: selfbookData.rate_code,
    });

    // update sessionStorage
    sessionStorage.setItem('gbBookingDetails', JSON.stringify(resData));
    sessionStorage.setItem('confirmationNumber', selfbookData.confirmationNumber);
    sessionStorage.setItem('currencyCode', selfbookData.currency); // undefined for some yotel properties?

    return resData;
  },
  /**
   * Used by Widget at checkout, EnrollmentMessage, and ConfirmationMessage
   * @returns rewards amount
   */
  getRewards: (percentage: number) => {
    let calculatedRewards = 0;
    let subtotal = Selfbook.displaySubtotal();
    calculatedRewards = Number((subtotal * percentage).toFixed(2));
    return calculatedRewards.toFixed(2);
  },
  /**
   * checks if messaging should be displayed
   * cross check passed in rate with list of package rate exclusions
   * @param rate: name of rate to match with package exclusion name
   * @returns true or false if rate is excluded
   */
  isRateExcluded: (rate: string) => {
    const packageRateExlusions =
      Selfbook.hotel.packageRateExlusions;
    for (const packageRateExlusion of packageRateExlusions as any) {
      if (rate === packageRateExlusion.name) {
        return true;
      }
    }
    return false;
  },
  /**
   * gets the rate exclusion matching the rate code
   * cross check passed in rate with list of package rate exclusions
   * @param rate: name of rate to match with package exclusion name
   * @returns the packageRateExlusion object associated with the passed in rate name
   */
  getRateExcluded: (rate: string) => {
    const packageRateExlusions =
      Selfbook.hotel.packageRateExlusions;
    for (const packageRateExlusion of packageRateExlusions as any) {
      if (rate === packageRateExlusion.name) {
        return packageRateExlusion;
      }
    }
  },
  /**
   * Checks if messaging should be displayed
   * sets rateExcluded in sessionStorage accordingly
   * @returns 
   */
  shouldDisplayMessaging: () => {
    sessionStorage.setItem("rateExcluded", "false");
    // if show enrollment (from AB is set to false)
    if (!JSON.parse(sessionStorage.getItem("gbShowEnrollment") || "true"))
      return false;

    const promoCode = Selfbook.getPromoCode ? Selfbook.getPromoCode() : "";
    const groupCode = Selfbook.getGroupCode ? Selfbook.getGroupCode() : "";
    const rateCodeExclusions = Selfbook.hotel.rateCodeExclusions;
    const currentPage = document.querySelector(Selfbook.selectors.ratesPage.title) ?
      document.querySelector(Selfbook.selectors.ratesPage.title).textContent.toLowerCase() :
      sessionStorage.getItem("currentPage");

    // blanket exclusions, check applied promo code against rate exclusions
    // Use once we have a use case
    // if (Selfbook.hotel.excludeAllPromoCodes) {
    //   if (promoCode) {
    //     sessionStorage.setItem("rateExcluded", "true");
    //     return false;
    //   }
    // } else if (Selfbook.hotel.exludeAllGroupCodes) {
    //   if (groupCode) {
    //     sessionStorage.setItem("rateExcluded", "true");
    //     return false;
    //   }
    // }

    // for (const rateCodeExclusion of rateCodeExclusions as any) {
    //   // Do not show if match exists
    //   if (
    //     rateCodeExclusion.rate_plan_code.toLowerCase() ===
    //       promoCode.toLowerCase() ||
    //     rateCodeExclusion.rate_plan_code.toLowerCase() ===
    //       groupCode.toLowerCase()
    //   ) {
    //     sessionStorage.setItem("rateExcluded", "true");
    //     return false;
    //   }
    // }

    // check selected rate on summary onwards
    if (currentPage == "summary" || currentPage == "payment" || currentPage == "checkout" || currentPage == "confirmation") {
      let selectedRateCode = sessionStorage.getItem("rateCode");
      if ((window as any).rewardProgramData)
        selectedRateCode = (window as any).rewardProgramData.rate_code;

      // regular implementation
      // for (const rateCodeExclusion of rateCodeExclusions as any) {
      //   if (
      //     rateCodeExclusion.rate_plan_code.toLowerCase() === selectedRateCode.toLowerCase() 
      //   ) {
      //     sessionStorage.setItem("rateExcluded", "true");
      //     return false;
      //   }
      // }

      // take inclusions into acct.
      let shouldDisplay = ![selectedRateCode].some(isNotEligibleForRewards);
      sessionStorage.setItem("rateExcluded", (!shouldDisplay).toString());
      return shouldDisplay;
    }

    // show messaging if all checks pass
    return true;
  },
  /** Uses waitUntilExists to check if the user should see widget
   * @param handler
   * (not usually modified)
   */
  addWidgetListener: (handler) => {
    const timeout = waitForSelectors(
      Selfbook.selectors.widget.waitFor,
      handler
    );
    if (Selfbook.activeIntervals) {
      Selfbook.activeIntervals.push(timeout);
    }
  },
  /** Uses waitUntilExists to check if the user is on rates page then executes the passed handler function
   * @param handler
   * (not usually modified)
   */
  addRatesPageListener: (handler) => {
    const timeout = waitForSelectors(
      Selfbook.selectors.ratesPage.waitFor,
      handler
    );
    if (Selfbook.activeIntervals) {
      Selfbook.activeIntervals.push(timeout);
    }
  },
  /** Uses waitUntilExists to check if the user is on payment page then executes the passed handler function
   * @param handler
   * (not usually modified)
   */
  addPaymentPageListener: (handler) => {
    const timeout = waitForSelectors(
      Selfbook.selectors.paymentPage.waitFor,
      handler
    );
    if (Selfbook.activeIntervals) {
      Selfbook.activeIntervals.push(timeout);
    }
  },
  /** Uses waitUntilExists to check if the user is on confirmation page then executes the passed handler function
   * @param handler
   * (not usually modified)
   */
  addConfirmationPageListener: (handler) => {
    const timeout = waitForSelectors(
      Selfbook.selectors.confirmationPage.waitFor,
      handler
    );
    if (Selfbook.activeIntervals) {
      Selfbook.activeIntervals.push(timeout);
    }
  },
  /** listen for cancellation number
   * @param handler
   */
  addCancellationPageListener: () => {
    if (Selfbook.addCancellationhandler) {
      const timeout = waitForSelectors(
        // modify selectors used based on the BE's cancellation implementation
        Selfbook.selectors.cancellation.waitFor,
        Selfbook.addCancellationhandler
      );
      if (Selfbook.activeIntervals) {
        Selfbook.activeIntervals.push(timeout);
      }
    }
  },
  /**
   * submit cancellation to 
   *    /api/v1/submit_booking_engine_cancellation
   */
  addCancellationhandler: () => {
    const confirmationNumber = (window as any).rewardProgramData.confirmationNumber;
    const cancellationNumber = confirmationNumber;
    const today = moment().format("YYYY-MM-DD");

    const submitCancellation = () => {
      if (cancellationNumber) {
        // confirmation_number used to find reservation record in our db
        // cancellation_number is arbitrary, in some cases, they are the same
        const cancellationData = {
          confirmation_number: confirmationNumber,
          cancellation_number: cancellationNumber,
          cancellation_date: today,
          hotel_identifier: window.gb_data.widget.identifier,
        };
        axios
          .post(
            `${guestbookSites[environment as string].rewardsdash.url
            }/api/v1/submit_booking_engine_cancellation`,
            cancellationData,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((response) => {
            if (response.data.success) {
              const element = document.querySelector(
                Selfbook.selectors.confirmationPage
                  .confirmationMessageContainer
              );
              if (!!element) {
                element.style.display = "none";
              }
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };
    submitCancellation();
  },
  /**
   * Creates widget container
   * (not usually modified)
   */
  createWidgetContainer: () => {
    document
      .querySelector(Selfbook.selectors.widget.widget)
      ?.remove();
    if (!document.querySelector(Selfbook.selectors.widget.widget)) {
      let messageTarget;

      if (window.innerWidth <= 767) {
        messageTarget = document.querySelector(Selfbook.selectors.widget.mobileWidgetTarget);
      } else {
        messageTarget = document.querySelector(Selfbook.selectors.widget.target);
      }

      if (messageTarget) {
        const injectedElement = document.createElement("div");
        injectedElement.id = Selfbook.selectors.widget.widget.substr(
          1
        );
        messageTarget.appendChild(injectedElement);
      }
    }
  },
  /**
   * Creates mobile widget container, usually at page head
   * (not usually modified)
   */
  createWidgetMobileContainer: () => {
    document
      .querySelector(Selfbook.selectors.widget.widget)
      ?.remove();
    if (!document.querySelector(Selfbook.selectors.widget.widget)) {
      const messageTarget = document.querySelector(
        Selfbook.selectors.widget.mobileWidgetTarget
      );
      if (messageTarget) {
        const injectedElement = document.createElement("div");
        injectedElement.id = Selfbook.selectors.widget.widget.substr(
          1
        );
        messageTarget.insertAdjacentElement("afterend", injectedElement);
      }
    }
  },
  /**
   * Creates enrollment checkbox message container
   * (not usually modified)
   */
  createEnrollmentMessageContainer: () => {
    if (
      !document.querySelector(
        Selfbook.selectors.paymentPage.enrollmentMessageContainer
      )
    ) {
      const enrollmentTarget = document.querySelector(
        Selfbook.selectors.paymentPage.enrollmentTarget
      );
      let messageTarget;
      if (enrollmentTarget) {
        messageTarget = enrollmentTarget;
      }
      if (messageTarget) {
        const injectedElement = document.createElement("div");
        injectedElement.id = Selfbook.selectors.paymentPage.enrollmentMessageContainer.substr(
          1
        );
        messageTarget.after(injectedElement);
      }
    }
  },
  /**
   * Creates confirmation message container
   * (not usually modified)
   */
  createConfirmationMessageContainer: () => {
    if (
      !document.querySelector(
        Selfbook.selectors.confirmationPage
          .confirmationMessageContainer
      )
    ) {
      const messageTarget = document.querySelector(
        Selfbook.selectors.confirmationPage.messageTarget
      );
      if (messageTarget) {
        const injectedElement = document.createElement("div");
        injectedElement.id = Selfbook.selectors.confirmationPage.confirmationMessageContainer.substr(
          1
        );
        messageTarget.insertAdjacentElement("afterend", injectedElement);
      }
    }
  },
  /**
   * Set locale used for messaging translations using
   */
  setLocale: () => {
    window.gb_data.I18n.locale = Selfbook.getLanguage();
  },
  /**
   * @return subtotal to use to calculate rewards and display on enrollment
   * can use in other functions to pull payment age subtotal
   */
  displaySubtotal: () => {
    let currentPage = document.querySelector(Selfbook.selectors.ratesPage.title).textContent.toLowerCase();
    let taxedRate = window.gb_data.hotel.taxedRate;
    let subtotal = 0;

    if (currentPage == "booking" ||
      currentPage == "select room" ||
      currentPage == "room details" ||
      currentPage == "additional rates and packages"
    ) {
      return 0;
    } else if (currentPage == "summary") {
      const bookingDetailsEl = document.querySelector("#selfbook-booking-details");
      if (!bookingDetailsEl) { return Number(sessionStorage.getItem('gbSubtotal')) }

      const summaryDetails = JSON.parse(bookingDetailsEl.textContent)
      subtotal = summaryDetails.prices.total_before_tax;
      sessionStorage.setItem('gbSubtotal', subtotal.toFixed(2));
    }
    else if (currentPage == "payment" || currentPage == "checkout") {
      subtotal = Number(sessionStorage.getItem('gbSubtotal'));
    } else if (currentPage == "confirmation") {
      let selfbookData = (window as any).rewardProgramData;
      subtotal = (Number(selfbookData.totalPriceLessTaxes) / taxedRate)
    }

    return subtotal;
  },
  /**
   * Triggers session storage reservation details save
   * can add additional listeners if needed
   */
  savePaymentPageInfo: () => {
    const saveReservationData = (): void => {
      const resData = Selfbook.getReservationData();
      sessionStorage.setItem("gbBookingDetails", JSON.stringify(resData));
    };
    saveReservationData();
  },
  /**
   * Clears all listeners
   * (not usually modified)
   */
  clearAllListeners: () => {
    if (!Selfbook.activeIntervals) return;
    let length = Selfbook.activeIntervals.length;
    for (let i = 0; i < length; i++) {
      let int = Selfbook.activeIntervals.pop();
      clearInterval(int);
    }
  },
  /**
   * Injects integration
   * (not usually modified)
   */
  injectIntegration: () => {
    handleIntegrationInjector(Selfbook);
  },
  /**
   * Mainly to handle widget scroll behavior
   * Best case, widget reanchors itself to page head underneath navbar on scroll
   * Otherwise it can stay anchored on the page bottom on mobile
   * reference Synxis for scroll and Guestline/Guestdesk for bottom anchored
   */
  additionalWidgetFunctions: () => {
    /*** Save page to sessionstorage ***/
    let currentPage = document.querySelector(Selfbook.selectors.ratesPage.title).textContent.toLowerCase();
    sessionStorage.setItem("currentPage", currentPage);

    // CSS add example
    if (
      document.querySelectorAll("#gb-override-styles-widget")
        .length === 0
    ) {
      document.head.insertAdjacentHTML(
        "beforeend",
        `<style id="gb-override-styles-widget" type="text/css">
          #guestbook-widget {
            width: 290px;
            margin-left: 2%;
          }
          .MuiAccordionSummary-content {
            align-content: center;
          }
          .gb-signup{
            cursor: pointer !important;
            min-width: unset !important;
            padding: 8px 12px !important;
            font-family: inherit !important;
            font-size: 16px !important;
            line-height: 16px !important;
            font-weight: 500 !important;
            text-transform: uppercase !important;
            width: fit-content !important;
            height: 35px !important;
            transition: all 0.4s ease-in-out !important;
            border-radius: 0px !important;
            background-color: #${gbData.widget.primaryColor} !important;
            color: #fff !important;
            border-width: 2px !important;
            border-style: solid !important;
            border-color: transparent !important;
          }
          .gb-login{
            cursor: pointer !important;
            min-width: unset !important;
            padding: 8px 12px !important;
            font-family: inherit !important;
            font-size: 16px !important;
            line-height: 16px !important;
            font-weight: 500 !important;
            text-transform: uppercase !important;
            width: fit-content !important;
            height: 35px !important;
            transition: all 0.4s ease-in-out !important;
            border-radius: 0px !important;
            background-color: #fff;
            background-color: rgb(240, 242, 244) !important;
            color: #${gbData.widget.primaryColor} !important;
            border-width: 2px !important;
            border-style: solid !important;
            border-color: #${gbData.widget.primaryColor} !important;
          }
          .gb-login-modal .gb-login-modal-button{
            background-color: #${gbData.widget.primaryColor} !important;
          }
          @media screen and (max-width: 768px){
            /* SELFBOOK OVERRIDES */
            #selfbook_sdkwidget_wrapper{
              // z-index: 2147400000 !important;
              // can check if z-index: 2147483647 first
            }
            #iprefer-rewards-wrapper > div{
              margin: 0 !important;
              padding-bottom: 0 !important;
            }
            #sb-top-wrapper{
              margin-top: 0px !important;
            }
            #hotel-heading-wrapper{
              margin-top: -10px !important;
            }
            #rewards_benefit_signup_footer {
              padding: 20px 30px !important;
            }

            /* GB ELEMENT OVERRIDES */
            #guestbook-widget{
              z-index: 2147483647 !important;
              /*  margin: -40px -30px 30px -30px !important;*/
              margin: -30px 0px 30px 0px !important;
              width: auto;
              background-color: rgb(240, 242, 244) !important;
              border-radius: 5px !important;
            }
            .outer-accordion-summary {
              justify-content: space-between !important;
            }
            .gb-widget-header-logo svg {
              /* filter: invert(100%) !important; */
            }
            .gb-widget-header-text {

            }
            .button-container {
              justify-content: center !important;
            }
            .gb-login-modal input{
              margin: 0 !important;
            }
            .MuiPaper-root.MuiAccordion-root{
              box-shadow: none !important;
            }
            .MuiButtonBase-root.MuiAccordionSummary-root {
              display: flex !important;
            }
            .inner-accordion-container{
              display: none !important;
            }
            .line{
              display: none !important;
            }
            .MuiAccordionDetails-root {
              display: flex !important;
              padding: 8px 16px 16px !important;;
            }
            .MuiCollapse-root.MuiCollapse-hidden{
              visibility: hidden !important;
            }
            .expand-more-icon{
              font-size: 1.5rem !important;
            }
          }
        </style>`
      );
    }
  },
  /**
   * CSS Overrides for rates page
   */
  additionalRatesPageFunctions: () => {
    /*** Save page to sessionstorage ***/
    let currentPage = document.querySelector(Selfbook.selectors.ratesPage.title).textContent.toLowerCase();
    sessionStorage.setItem("currentPage", currentPage);

    /*** Hide/Show enrollment message when selfbook modals are active ***/
    if (document.querySelectorAll("div[aria-label='Price Breakdown'], #sb-modalcontent").length > 0) {
      window.jQuery("#guestbook-enrollment").hide();
    } else {
      window.jQuery("#guestbook-enrollment").show();
    }

    /**** CSS add ****/
    if (
      document.querySelectorAll("#gb-override-styles-rates-page")
        .length === 0
    ) {
      document.head.insertAdjacentHTML(
        "beforeend",
        `<style id="gb-override-styles-rates-page" type="text/css">
          /* SELFBOOK OVERRIDES */
          #selfbook_sdkwidget_wrapper{
            // z-index: 2147400000 !important;
          }
          /* GB ELEMENT OVERRIDES */
          .rewards_benefit_rate-wrapper{
            z-index: 2147483640 !important;
            margin-bottom: -3px !important;
            margin-top: -3px !important;
          }
          .icon-container svg {
            display: inline !important;
          }
          .gb-rates-message {
            font-size: 14px !important;
            max-width: 200px !important;
            text-align: end !important;
          }
          #gb-hoverover{
            z-index: 9999999999 !important; 
          }
          div[aria-label='Basic Settings'],
          div[aria-label='Global Settings'],
          div[aria-label='Price Breakdown']{
            z-index: 2147483647 !important;
          }

          @media screen and (max-width: 415px) {
            .gb-banner {
              position: absolute !important;
              right: 20px !important;
              font-size: 13px !important;
              width: 100px !important;
              margin-top: 0px !important;
            }
          }
        </style>`
      );
    }
  },
  // We'll need to add margin for the enrollment message
  additionalPaymentsPageFunctions: () => {
    if (document.querySelector(Selfbook.selectors.paymentPage.email)) {
      Selfbook.prefillUserInfo(
        sessionStorage.getItem("gbFirstName"),
        sessionStorage.getItem("gbLastName"),
        sessionStorage.getItem("gbEmail")
      );
    }
    /**** CSS add ****/
    if (
      document.querySelectorAll("#gb-override-styles-payment-page")
        .length === 0
    ) {
      document.head.insertAdjacentHTML(
        "beforeend",
        `<style id="gb-override-styles-payment-page" type="text/css">
          /* SELFBOOK OVERRIDES */
          
          /* GB ELEMENT OVERRIDES */
          .wide-logo-container svg{
            ${Selfbook.hotel.desktopEnrollmentPrimaryColor ?
          "" :
          "filter: invert(80) !important;"
        }
          }
          #guestbook-enrollment{
            margin-top: 15px !important;
          }
          .nonMemberMessageContainer {
            font-size: 14px !important;
            margin-top: -2px;
          }
          .memberMessageContainer{
            font-size: 14px !important;
          }
          .gb-enrollment-container {
            border-radius: 5px !important;
          }
          .gb-form-control-label {
            display: inline-flex !important;
            font-size: 14px !important;
            font-weight: 400 !important;
          }
          .checkbox-container {
            margin-top: 25px !important;
          }
          .checkbox{
            margin-right: 6px !important;
          }
          .terms{
            cursor: pointer !important;
          }
          .partner-hotels{
            cursor: pointer !important;
          }
          .MuiCheckbox-root {
            display: flex !important;
            max-width: 42px !important;
            padding: 10px;
          }
          .MuiIconButton-label {
            display: flex !important;
          }
          .MuiIconButton-root {
            border-radius: 50% !important;
          }
        </style>`
      );
    }
  },
  additionalConfirmationPageFunctions: () => {
    /**** CSS add ****/
    if (
      document.querySelectorAll("#gb-override-styles-confirmation-page")
        .length === 0
    ) {
      document.head.insertAdjacentHTML(
        "beforeend",
        `<style id="gb-override-styles-confirmation-page" type="text/css">
          /* SELFBOOK OVERRIDES */
          
          /* GB ELEMENT OVERRIDES */
          #guestbook-confirm {
            margin-top: -30px !important;
          }
          .confirmation-container {
            color: #212529 !important;
          }
          .logo-container svg {
            filter: invert(100%) !important;
          }
          .guestbook-widget-desktop {
            display: none;
          }
        </style>`
      );
    }
  }
};

export default Selfbook;
